import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Newsletter: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m660 600h-540v-420h465c41.36 0 75 33.65 75 75zm-510-30h480v-315c0-24.81-20.19-45-45-45h-435z' />
    <path d='m390.16 420.06c-9.94 0-19.88-3.46-28.14-10.39l-236.65-198.17 19.26-23 236.65 198.17c5.27 4.41 12.37 4.44 17.67.08l221.53-182.32 19.06 23.16-221.53 182.32c-8.22 6.76-18.04 10.14-27.85 10.14z' />
  </IconBase>
));

Newsletter.displayName = 'Newsletter';

export default Newsletter;
